import { useAtom } from 'jotai';
import { Dialog } from '../../../../dialog/dialog';
import { ExportConfigForm } from './config-form';
import { ExportInProgressDialog } from './in-progress-dialog';
import { exportChartAtom, exportDataAtom } from './state';
import { ExportSuccessDialog } from './success-dialog';

export const ExportFlow = () => {
  const [exportChartType, setExportChartType] = useAtom(exportChartAtom);
  const [exportData, setExportData] = useAtom(exportDataAtom);

  return (
    <Dialog
      open={Boolean(exportChartType)}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          setExportChartType(null);
          setExportData(null);
        }
      }}
    >
      {exportData === null && <ExportConfigForm />}
      {exportData !== null && ['QUEUED', 'PROCESSING'].includes(exportData.status) && (
        <ExportInProgressDialog exportId={exportData.exportId} />
      )}
      {exportData !== null && ['READY_FOR_DOWNLOAD', 'EMAILED'].includes(exportData.status) && (
        <ExportSuccessDialog exportId={exportData.exportId} status={exportData.status} />
      )}
    </Dialog>
  );
};
